<div id="forgot-password-success-container" fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%">
        <mat-card-title>{{ titleText }}</mat-card-title>
        <mat-card-content>
            {{ content  }}
            <br>
            <span *ngIf = "adminEmail">Admin Email Id - <span class = "link"><u>{{adminEmail}}</u></span></span>
        </mat-card-content>
    </mat-card>
  </div>
